import axios from '../axios'

export const createOrder = (payload) =>
    axios.post('/shopping/buy/packages', payload)

export const findOrderPaying = (orderId) =>
    axios.get('/shopping/order-' + orderId)
